import { createContext } from 'react';

export const MenuLoggedContext = createContext();
